export var NON_BOOLEAN_VALUE = 'non_boolean';